import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CockpitProcess, ProcessCockpit } from '@apps/file-process/file-process.state';
import { sliceArray } from '@platform/shared/utilities/obserables-utils';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-processes-widget-table',
  templateUrl: './processes-widget-table.component.html',
  styleUrls: ['./processes-widget-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessesWidgetTableComponent {
  @Input() customerSpaceId: string;
  @Input() processes$: Observable<ReadonlyArray<CockpitProcess>>;
  @Input() displayRowsCount = 6;
  displayedColumns = ['name'];

  get processesSliced$() {
    return this.processes$.pipe(sliceArray(this.displayRowsCount));
  }
}
